import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getDisplayName } from 'components/hoc';
import { LayoutTriggerValueType } from 'defs/layout';
import { actionCreators as layoutAC, getGoTopTimestamp, getIsBodyLocked } from 'store/layout';

export type WithLayoutPropsType = {
	doLockBody: (trigger?: LayoutTriggerValueType, opts?: Object) => void;
	doUnlockBody: (trigger?: LayoutTriggerValueType) => void;
	doGoTop: (trigger?: LayoutTriggerValueType) => void;
};

const mapStateToProps = (state) => ({
	bodyLocked: getIsBodyLocked(state),
	goTopTimestamp: getGoTopTimestamp(state),
});

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			doLockBody: layoutAC.doLockBody,
			doUnlockBody: layoutAC.doUnlockBody,
			doGoTop: layoutAC.doGoTop,
		},
		dispatch
	);

/*
 * @version 1.0.0
 * @author Jan Biasi <biasijan@gmail.com>
 * @param {React.Component} WrappedComponent
 */
export default function withLayout<P extends object>(WrappedComponent: React.ComponentType<P>) {
	class WithLayoutProxy extends React.Component<
		P & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>
	> {
		public static displayName = `withLayout(${getDisplayName(WrappedComponent)})`;

		public render() {
			const { bodyLocked, goTopTimestamp, doLockBody, doUnlockBody, doGoTop } = this.props;

			return (
				<WrappedComponent
					{...(this.props as P)}
					doLockBody={doLockBody}
					doUnlockBody={doUnlockBody}
					doGoTop={doGoTop}
					bodyLocked={bodyLocked}
					goTopTimestamp={goTopTimestamp}
				/>
			);
		}
	}

	return connect(mapStateToProps, mapDispatchToProps)(WithLayoutProxy as any);
}
